import React from 'react';

import Thumb from '../img/blogs/react.jpg';
import DOM from '../img/blog-details/react-intro-and-behind-the-scene/dom.png';

const ReactJSIntroAndBehindTheScene = {
    id: 10, permalink: "react-intro-and-behind-the-scene", thumb: Thumb, postBy: "Wasek Bellah", postDate: "May 04, 2020", categories: "ReactJS", title: "ReactJS Intro and Behind the Scene", shortDesc: "React is a declarative, efficient, and flexible JavaScript library for creating responsive user interfaces. It is maintained by Facebook and a community of individual developers and organizations.", fullDesc: <>
        <h2>What is React?</h2>
        <p><strong>React</strong> is a declarative, efficient, and flexible <strong>JavaScript library</strong> for creating responsive user interfaces. It is maintained by <strong>Facebook</strong> and a community of individual <strong>developers</strong> and <strong>organizations</strong>. <strong>React</strong> can be used as a base for <strong>developing single-page applications</strong>. It allows you to compose complex UIs from short and isolated pieces of code called "<strong>components</strong>"”".</p>


        <h2>What is a DOM (Document Object Model)?</h2>
        <p>The <strong>Document Object Model (DOM)</strong> is a <strong>programming</strong> interface for <code>HTML</code> and <code>XML</code> (Extensible Markup Language) documents. It defines the logical structure of the document and the way it accesses and manages a document. When a webpage is loaded, the browser creates the <strong>DOM</strong> of the page. It presents documents as <strong>nodes or objects</strong>.</p>

        <p><em>A basic <strong>DOM</strong> looks like this</em>:</p>
        <div className="smallImg">
            <img src={DOM} alt="DOM" width="600" />
        </div>


        <h2>ReactJS and DOM</h2>
        <p><strong>ReactJS</strong> uses the concept of <strong>virtual DOM</strong> which makes the loading faster. A <strong>virtual DOM</strong> is a lightweight <strong>JavaScript object</strong> that is just a copy of the <strong>real DOM</strong>.</p>

        <p><em>The <strong>Virtual DOM</strong> works in the following 3 steps</em>:</p>
        <ul>
            <li>1. Whenever a prop or state changes, the entire <strong>UI</strong> is re-rendered in the <strong>virtual DOM</strong>.</li>
            <li>2. The difference between the <strong>previous DOM (real DOM)</strong> and the <strong>new DOM (virtual DOM)</strong> is evaluated using separate algorithms.</li>
            <li>3. After the final calculation, the <strong>real DOM</strong> will only be updated with components that have actually changed.</li>
        </ul>


        <h2>React’s tree reconciliation</h2>
        <p>When we tell <strong>React</strong> to render a <strong>tree</strong> of elements in the browser, it first generates a virtual representation of that <strong>tree</strong> and then keeps it in memory. It will then continue to perform the <strong>DOM</strong> operations which will show the tree in the browser.</p>

        <p>When we tell <strong>React</strong> to update the <strong>tree</strong> of previously rendered elements, it generates a new virtual representation of the updated <strong>tree</strong>. Now <strong>React</strong> has two versions of the <strong>tree</strong> in memory.</p>

        <p>To render the updated <strong>tree</strong> in the browser, <strong>React</strong> does not discard the response that has already been rendered. Instead, it will compare the two virtual versions of the tree that it has in memory, compare the differences between them, determine what <strong>sub-trees</strong> in the main tree need to update, and update only these <strong>sub-trees</strong> in the browser.</p>

        <p>This process is known as the <strong>tree</strong> reconciliation algorithm.</p>


        <h2>What is JSX?</h2>
        <p><strong>JSX</strong> is an <strong>XML/HTML</strong>-like syntax used by <strong>React</strong> that extends <strong>ECMAScript</strong> so that <strong>XML/HTML</strong>-like text can co-exist with <strong>JavaScript/React</strong> code. <strong>JSX</strong> is allowed to put <strong>HTML</strong> code in <strong>JavaScript</strong> code. and also put <strong>JavaScript</strong> code in <strong>HTML</strong> code.</p>

        <pre className="code">
            return( <br />
                &nbsp; &lt;div&gt; <br />
                    &nbsp;   Name: &#123;name&#125; <br />
                &nbsp; &lt;/div&gt; <br />
            )
        </pre>


        <h2>First React example</h2>
        <p><em>A simple <strong>HTML</strong> element is rendered to the display using 2 methods</em>:</p>
        <p><em>1: Using the <strong>Web DOM API</strong> directly</em>:</p>
        <pre className="code">
            document.getElementById('root').innerHTML = ` <br />
                &nbsp; &lt;div&gt; <br />
                    &nbsp;   Hello HTML Example <br />
                &nbsp; &lt;/div&gt; <br />
            `;
        </pre>

        <p><em>2: Using <strong>React’s API</strong></em>:</p>
        <pre className="code">
            ReactDOM.render( <br />
                &nbsp; React.createElement( <br />
                    &nbsp;   'div', <br />
                    &nbsp;   null,  <br />
                    &nbsp;   'Hello React Example' <br />
                &nbsp; ), <br />
                &nbsp; document.getElementById('root'), <br />
            );
        </pre>

        <p>The <code>ReactDOM.render()</code> and <code>React.createElement()</code> methods are the core <strong>API</strong> methods in a <strong>React application</strong>. A <strong>React web application</strong> cannot exist without using these two methods.</p>


        <h2>ReactDOM.render()</h2>
        <p>This is basically the entry point for a <strong>React application</strong> into the browser’s <strong>DOM</strong>. <em>It has 2 arguments</em>:</p>
        <ul>
            <li>The first argument is what to render in the browser. It is always a "<strong>React element</strong>".</li>
            <li>The second argument is where to render that <strong>React element</strong> in the browser. It must be a valid <strong>DOM</strong> node that exists in the static rendered <strong>HTML</strong>.</li>
        </ul>

        <p><strong>React element</strong> is a virtual element that describes a <strong>DOM</strong> element. It’s what the <code>React.createElement()</code> <strong>API</strong> method returns.</p>


        <h2>React.createElement()</h2>
        <p>Using the <code>React.createElement()</code> method, We represent <strong>DOM</strong> elements with <strong>objects</strong>. These <strong>objects</strong> are known as <strong>React elements</strong>.</p>

        <p><em>The <code>React.createElement()</code> function has many arguments</em>:</p>
        <ul>
            <li>The first argument is the <strong>HTML "tag"</strong> for the <strong>DOM</strong> element to represent.</li>
            <li>The second argument is for any <strong>HTML attributes</strong> (like id, class, title, etc.) that we want to the <strong>DOM</strong> element. If no attributes needs, have to use <code>null</code>.</li>
            <li>The third argument is the content of the <strong>DOM</strong> element.</li>
        </ul>

        <pre className="code">
            React.createElement( <br />
                &nbsp; 'div', <br />
                &nbsp; &#123; id: "myDiv" &#125;, <br />
                &nbsp; 'Hello React Example' <br />
            )
        </pre>
        <p>This will create <code className="output">&lt;div id="myDiv"&gt;Hello React Example&lt;&#47;div&gt;</code></p>
        <p><code>React.createElement()</code> can also be used to create elements from <strong>React components</strong>.</p>


        <h2>Nesting React elements</h2>
        <p>Let's add more <strong>HTML</strong> elements to the simple UI.</p>

        <p>For the <strong>HTML</strong> version, we can only inject the new element's tag directly inside the template:</p>
        <pre className="code">
            document.getElementById('root').innerHTML = ` <br />
                &nbsp; &lt;div&gt; <br />
                    &nbsp;   Hello HTML Example <br />
                    &nbsp;   &lt;input /&gt; <br />
                &nbsp; &lt;/div&gt; <br />
            `;
        </pre>

        <p>To do the same with <strong>React</strong>, we can add more arguments after the third argument for <code>React.createElement()</code>.</p>

        <pre className="code">
            ReactDOM.render( <br />
                &nbsp; React.createElement( <br />
                    &nbsp;   'div', <br />
                    &nbsp;   null,  <br />
                    &nbsp;   'Hello React Example', <br />
                    &nbsp;   React.createElement("input") <br />
                &nbsp; ), <br />
                &nbsp; document.getElementById('root'), <br />
            );
        </pre>


        <h2>React Fiber</h2>
        <p><strong>React Fiber</strong> is an ongoing re-implementation of the original algorithm of <strong>React</strong>.</p>

        <p><strong>React Fiber</strong> aims to increase its suitability in areas such as <strong>animation</strong>, <strong>layout</strong>, and <strong>gestures</strong>. Its title feature is Incremental Rendering: the ability to split rendering work into pieces and spread them across multiple frames.</p>

        <p>Other key features include the ability to <strong>pause</strong>, <strong>abort</strong>, or <strong>reuse </strong>work as new updates arrive.</p>
    </>
};
export default ReactJSIntroAndBehindTheScene;